'use client'

import type { TextBlockFieldsFragment } from '@/graphql/types'
import { useContentfulEntryLivePreview } from '@/components/providers/useContentfulEntryLivePreview'

import { DynamicTextBlock } from '@ccpgames/eve-web-core'

import { richTextRendererDlp } from '../rich-text'
import styles from './TextBlock.module.css'

interface TextBlockProps {
  entry: TextBlockFieldsFragment
}

export function TextBlock({ entry }: TextBlockProps) {
  const { updatedEntry, inspectorProps } = useContentfulEntryLivePreview(entry)

  return (
    <div {...inspectorProps('text')} className={styles.content}>
      <DynamicTextBlock title={updatedEntry.title} content={richTextRendererDlp(updatedEntry.text)} />
    </div>
  )
}
